import emailjs from 'emailjs-com';
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bounce, toast, ToastContainer } from "react-toastify";

import "./hero.css";
import { sendDataToApi } from '../form/FormUtils';

const Hero = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let waitListUrl = import.meta.env.VITE_WAIT_LIST_URL as string;
    sendDataToApi(waitListUrl,"", formData, navigate);


    const serviceId = import.meta.env.VITE_EMAILJS_SERVICE_ID as string;
    const publickKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY as string;
    const templateId = import.meta.env.VITE_EMAILJS_TEMPLATE_ID as string;
    emailjs.send(serviceId, templateId, formData, publickKey)
    .then((response)=>{
      console.log(response);
      setIsModalOpen(false);
      setFormData({ name: "", email: "", message: "" });
      toast.success("Thank you! You've been added to the waitlist!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
    })
    .catch((error)=>{
      console.log(error);
      toast.error("Something went wrong", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
    })
  };
  return (
    <section className="section pb-0 hero-section" id="hero">
      <ToastContainer />
      <div className="container">
        <div className="row justify-content-start">
          <div className="col-lg-12 col-sm-14">
            <div className="row">
              <div className="col-lg-7 text-center mt-lg-5 pt-5 mb-lg-3">
                <h1 className="display-4 fw-semibold mb-3 lh-2">
                  Your gateway to <span style={{ color: "#d9c4ab" }}>funding</span> and <span style={{ color: "#d9c4ab" }}>efficiency</span>
                </h1>
                <p className="lead text-muted lh-1.5 fs-5">
                  Oasys is a web application that helps event organizers secure event funding through proprietary
                  match-making algorithms
                </p>
                <div className="d-flex gap-2 justify-content-center mt-4">
                  <Link to="/register" className="btn btn-primary" onClick={() => console.log("Navigating to /register")}>
                    Get Started <i className="ri-arrow-right-line align-middle ms-1"></i>
                  </Link>
                  <Link to="/" className="btn btn-danger" onClick={() => setIsModalOpen(true)}>
                    Join the Waitlist 
                  </Link>
                </div>
              </div>
              <div className="col-lg-5 mt-4 mt-sm-5 pt-sm-5 mb-sm-n5 demo-carousel">
                <div className="demo-img-patten-top d-none d-sm-block">
                  <img src="assets/images/landing/img-pattern.png" className="d-block img-fluid" alt="..." />
                </div>
                <div className="demo-img-patten-bottom d-none d-sm-block">
                  <img src="assets/images/landing/img-pattern.png" className="d-block img-fluid" alt="..." />
                </div>

                
                <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
                  {/* Indicators */}
                  <div className="carousel-indicators">
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
                  </div>

                  
                  <div className="carousel-inner shadow-lg p-2 bg-white rounded">
                    <div className="carousel-item active" data-bs-interval="2000">
                      <img src="assets/images/demos/oasy1.jpg" className="d-block w-100" alt="..." />
                    </div>
                    <div className="carousel-item" data-bs-interval="2000">
                      <img src="assets/images/demos/oasy2.jpg" className="d-block w-100" alt="..." />
                    </div>
                    <div className="carousel-item" data-bs-interval="2000">
                      <img src="assets/images/demos/oasy3.jpg" className="d-block w-100" alt="..." />
                    </div>
                    <div className="carousel-item" data-bs-interval="2000">
                      <img src="assets/images/demos/oasy4.jpg" className="d-block w-100" alt="..." />
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="position-absolute start-0 end-0 bottom-0 hero-shape-svg">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
          <g mask="url(&quot;#SvgjsMask1003&quot;)" fill="none">
            <path d="M 0,118 C 288,98.6 1152,40.4 1440,21L1440 140L0 140z"></path>
          </g>
        </svg>
      </div>
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            
            <div className="modal-header">
              <h3>Join the Future</h3>
              <a className="close-btn" onClick={() => setIsModalOpen(false)}>&times;</a>
            </div>

            <p className="lead">Be among the first to experience Oasys</p>

            
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Optional Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <button type="submit" className="btn btn-primary">Count Me In</button>
            </form>
          </div>
        </div>
      )}


      
      <div className="position-absolute start-0 end-0 bottom-0 hero-shape-svg">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
          <g fill="none">
            <path d="M 0,118 C 288,98.6 1152,40.4 1440,21L1440 140L0 140z"></path>
          </g>
        </svg>
      </div>

    </section>
  );
};

export default Hero;